
import Vue from "vue";
import Component from "vue-class-component";

@Component<Textfield>({
  props: {
    value: {
      type: Object,
      default() {
        return { label: "Label", value: "", error: "" };
      }
    },
    val: {
      type: [String, Number],
      default: undefined
    },
    label: {
      type: String,
      default: undefined
    },
    error: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    password: {
      type: Boolean,
      default: false
    },
    number: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ""
    },
    persistentHint: {
      type: Boolean,
      default: false
    },
    success: {
      type: String,
      default: ""
    },
    singleLine: {
      type: Boolean,
      default: false
    }
  }
})
export default class Textfield extends Vue {
  private get type(): string {
    return this.$props.password
      ? "password"
      : this.$props.number
      ? "number"
      : "text";
  }
}
